import axios from 'axios';
import swal from 'sweetalert';
import myFirebase from '../config/config';
import getFileMimeType from './getFileMimeType';
import apiCaller from './apiCallerOutstanding';

const { REACT_APP_API_BASE_URL } = process.env;

async function getSignedURL(body, UploadedFile) {
  const mime = await getFileMimeType(UploadedFile);

  if (mime !== 'Unknown file type') {
    const fileBody = body;
    fileBody.ext = mime;
    const userDetails = myFirebase.auth().currentUser;
    const { Aa } = userDetails;
    const token = Aa;
    const endPoint = `${REACT_APP_API_BASE_URL}pipe/files`;

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      return axios.post(endPoint, fileBody, config);
    } catch (e) {
      throw new Error(e);
    }
  } else {
    swal('Oops!', 'Unknown file type. Please upload a valid file.', 'error');
    throw new Error('Unknown file type');
  }
}

async function getSignedURLNew(body, UploadedFile) {
  const mime = await getFileMimeType(UploadedFile);
  if (mime !== 'Unknown file type') {
    const fileBody = body;
    fileBody.extension = mime;
    const userDetails = myFirebase.auth().currentUser;
    const { Aa } = userDetails;
    const token = Aa;
    const endPoint = `pipe/upload-file`;
    try {
      return await apiCaller(
        endPoint,
        fileBody,
        `Bearer ${token}`,
        'nh-base',
        'post'
      );
    } catch (e) {
      throw new Error(e);
    }
  } else {
    swal('Oops!', 'Unknown file type. Please upload a valid file.', 'error');
    throw new Error('Unknown file type');
  }
}

async function getTransactionsSignedURL(body, UploadedFile) {
  const mime = await getFileMimeType(UploadedFile);
  if (mime !== 'Unknown file type') {
    const fileBody = body;
    fileBody.extension = mime;
    const userDetails = myFirebase.auth().currentUser;
    const { Aa } = userDetails;
    const token = Aa;
    const endPoint = `pipe/upload-transaction-file`;
    try {
      return await apiCaller(
        endPoint,
        fileBody,
        `Bearer ${token}`,
        'nh-base',
        'post'
      );
    } catch (e) {
      throw new Error(e);
    }
  } else {
    swal('Oops!', 'Unknown file type. Please upload a valid file.', 'error');
    throw new Error('Unknown file type');
  }
}

async function fileUploader(url, File) {
  try {
    await axios.put(url, File, {
      headers: {
        'content-Type': File?.type,
      },
    });

    return 'success';
  } catch (e) {
    throw new Error(e);
  }
}

async function fileUploaderNew(url, metaData, File) {
  try {
    await axios.put(url, File, {
      headers: {
        'Content-Type': File?.type,
        'x-amz-meta-metadata': metaData,
      },
    });

    return 'success';
  } catch (e) {
    throw new Error(e);
  }
}

function getViewURL(body) {
  const userDetails = myFirebase.auth().currentUser;
  const { Aa } = userDetails;
  const token = Aa;
  const endPoint = `${REACT_APP_API_BASE_URL}pipe/files`;

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    return axios.post(endPoint, body, config);
  } catch (e) {
    throw new Error(e);
  }
}

function getViewURLNew(body) {
  const userDetails = myFirebase.auth().currentUser;
  const { Aa } = userDetails;
  const token = Aa;
  const truckNumber = body?.truck_number
    ? `&truck_number=${body?.truck_number}`
    : '';
  const bankId = body?.bank_id ? `&bank_id=${body?.bank_id}` : '';
  const endPoint = `pipe/trucker-view-file?role=${body.role}&trucker_id=${body.trucker_id}&file_type=${body.file_type}${truckNumber}${bankId}`;

  try {
    return apiCaller(endPoint, {}, `Bearer ${token}`, 'nh-base', 'get');
  } catch (e) {
    throw new Error(e);
  }
}

function getTransactionsViewURL(body) {
  const userDetails = myFirebase.auth().currentUser;
  const { Aa } = userDetails;
  const token = Aa;
  const endPoint = `pipe/v2/transaction-view-files?role=${body.role}&transaction_id=${body.transaction_id}&file_type=${body.file_type}`;
  try {
    return apiCaller(endPoint, {}, `Bearer ${token}`, 'nh-base', 'get');
  } catch (e) {
    throw new Error(e);
  }
}

function deleteFileHandler(body) {
  const userDetails = myFirebase.auth().currentUser;
  const { Aa } = userDetails;
  const token = Aa;
  const endPoint = `${REACT_APP_API_BASE_URL}pipe/files`;

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    return axios.post(endPoint, body, config);
  } catch (e) {
    throw new Error(e);
  }
}

async function deleteFileHandlerNew(body) {
  const userDetails = myFirebase.auth().currentUser;
  const { Aa } = userDetails;
  const token = Aa;
  const endPoint = `pipe/delete-trucker-file`;
  try {
    await apiCaller(endPoint, body, `Bearer ${token}`, 'nh-base', 'post');
  } catch (e) {
    throw new Error(e);
  }
}

async function deleteTransactionsFileHandler(body) {
  const userDetails = myFirebase.auth().currentUser;
  const { Aa } = userDetails;
  const token = Aa;
  const endPoint = `pipe/transaction-delete-files`;
  try {
    await apiCaller(endPoint, body, `Bearer ${token}`, 'nh-base', 'post');
  } catch (e) {
    throw new Error(e);
  }
}

export {
  getSignedURL,
  fileUploader,
  getViewURL,
  deleteFileHandler,
  deleteFileHandlerNew,
  getSignedURLNew,
  getViewURLNew,
  fileUploaderNew,
  getTransactionsViewURL,
  getTransactionsSignedURL,
  deleteTransactionsFileHandler,
};
